import React, { useEffect, useState } from 'react'
import Nav from './Nav'
import stocksOptions from '../dataset/stocks.json'
import '../App.css';


const Search = ({ theme, setItem, onClose }) => {

    const [text, setText] = useState('')
    const [result, setResult] = useState([])

    useEffect(() => {
        if (text.length > 0) {
            let res = stocksOptions.filter(s => s.id.indexOf(text) === 0 || s.name.indexOf(text) === 0) //開頭優先
            if (res.length === 0) {
                res = stocksOptions.filter(s => s.id.indexOf(text) > 0 || s.name.indexOf(text) > 0)
            }
            res.sort((a, b) => (a.id.length - b.id.length))
            if (res.length > 30) {
                res = res.slice(0, 30)
            }
            setResult(res)
        }

    }, [text])

    const enter = (ev) => {
        setText(ev.target.value)
    }

    const txt = theme === 'dark' ? 'text-white' : 'text-black'
    const bgColor = theme === 'dark' ? '#0F0F0F' : '#ffffff'
    const borderColor = theme === 'dark' ? 'rgba(255,255,255, 0.125)' : 'rgba(0,0,0, 0.125)'
    const inputCls = theme === 'dark' ? 'sb-input-dark' : 'sb-input-light'


    return (
        <>
            <Nav theme={theme} title="搜尋個股" onBack={onClose} />
            <div className='p-2'>
                <input id="search_box" className={"form-control " + txt + " " + inputCls}
                    type="text" value={text} onChange={enter} placeholder="輸入代號或名稱" autoFocus={true} />
            </div>
            {
                text.length > 0 &&
                <div className={txt}>
                    <div className='px-2'>{text} 的搜尋結果</div>
                    <ul className="list-group list-group-flush" >
                        {
                            result.map(s => {
                                return (
                                    <li key={s.id} className={"list-group-item"} style={{ backgroundColor: bgColor, borderColor }} onClick={() => setItem(s.id+' '+s.name)}>{s.id} {s.name}</li>
                                )
                            })
                        }
                    </ul>
                </div>
            }
        </>
    )

}

export default Search